import "@/App.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";

import LandingSport from "@/pages/LandingSport";
import DepartmentSelector from "@/pages/DepartmentSelector";
import DepartmentLayout from "@/pages/department/DepartmentLayout";
import DeptHome from "@/pages/department/DeptHome";
import DeptTeam from "@/pages/department/DeptTeam";
import DeptClients from "@/pages/department/DeptClients";
import DeptServices from "@/pages/department/DeptServices";
import DeptContact from "@/pages/department/DeptContact";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import Gate, { hasSiteAccess } from "@/pages/Gate";

function RequireAdmin({ children }) {
  const { user, checking } = useAuth();
  if (checking) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center text-white/60">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  const [unlocked, setUnlocked] = useState(hasSiteAccess());
  useEffect(() => {
    const check = () => setUnlocked(hasSiteAccess());
    window.addEventListener("focus", check);
    return () => window.removeEventListener("focus", check);
  }, []);

  if (!unlocked) {
    return (
      <div className="App">
        <Gate onUnlock={() => setUnlocked(true)} />
        <Toaster theme="dark" position="top-center" richColors />
      </div>
    );
  }

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingSport />} />
            <Route path="/sport/:sport" element={<DepartmentSelector />} />

            <Route path="/d/:slug" element={<DepartmentLayout />}>
              <Route index element={<DeptHome />} />
              <Route path="team" element={<DeptTeam />} />
              <Route path="clients" element={<DeptClients />} />
              <Route path="services" element={<DeptServices />} />
              <Route path="contact" element={<DeptContact />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <RequireAdmin>
                  <AdminDashboard />
                </RequireAdmin>
              }
            />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster theme="dark" position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
